import { hasOwn } from '../hasOwn';
import { isValidEmail } from '../isValidEmail';

import { ValidationError } from './ValidationError';

const PASSWORD_MIN_LENGTH = 8;
const USERNAME_MIN_LENGTH = 3;
const USERNAME_MAX_LENGTH = 64;
const VALID_USERNAME = /^[a-zA-Z][a-zA-Z0-9@._-]+[a-zA-Z0-9]$/;

type User = {
  username?: string;
  password?: string;
  email?: string;
};

type Options = {
  allowEmptyPassword?: boolean;
  allowPartial?: boolean;
};

export function validateUser(user: User, options: Options = {}) {
  const { username, password = '', email } = user;
  const { allowEmptyPassword = false, allowPartial = false } = options;
  if (!allowPartial || hasOwn(user, 'username')) {
    if (!username || username.length < USERNAME_MIN_LENGTH) {
      throw new ValidationError(
        'Field "{field}" must be at least {length} characters in length',
        { field: 'username', length: USERNAME_MIN_LENGTH },
      );
    }
    if (username.length > USERNAME_MAX_LENGTH) {
      throw new ValidationError(
        'Field "{field}" must be no more than {length} characters in length',
        { field: 'username', length: USERNAME_MAX_LENGTH },
      );
    }
    if (!VALID_USERNAME.test(username)) {
      throw new ValidationError('Field "{field}" contains invalid characters', {
        field: 'username',
      });
    }
  }
  if (!allowPartial || hasOwn(user, 'password')) {
    if (!allowEmptyPassword) {
      // TODO: Password complexity checks?
      if (!password || password.length < PASSWORD_MIN_LENGTH) {
        throw new ValidationError(
          'Field "{field}" must be at least {length} characters in length',
          { field: 'password', length: PASSWORD_MIN_LENGTH },
        );
      }
    }
  }
  if (!allowPartial || hasOwn(user, 'email')) {
    if (!email || !isValidEmail(email)) {
      throw new ValidationError('Field "{field}" is not valid', {
        field: 'email',
      });
    }
  }
}
